export enum UserStatus {
  INVITED = 'Invited',
  ACTIVE = 'Active',
  DEACTIVATED = 'Deactivated',
}

type User = {
  id: number;
  firstName: string;
  lastName: string;
  countryId: string;
  email: string;
  department: string;
  title: string;
  role: string;
  country: Record<string, any>;
  languages: string[];
  languagesData: Record<string, any>[];
  formattedCreatedDate: string;
  formattedLastModifiedDate: string;
};
export type { User };
